import React from 'react'

function Icon() {
    return (
        <svg
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={32} height={32} rx={3} fill="#F3F3F3" />
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={4}
      y={4}
      width={32}
      height={32}
    >
      <path fill="#D9D9D9" d="M4 4h24v24H4z" />
    </mask>
    <g mask="url(#a)">
      <path
        d="M14.725 24.5a.52.52 0 0 1-.413-.188.49.49 0 0 1-.112-.437l.85-6h-3.1q-.375 0-.45-.187t.125-.513l5.175-9.4a.4.4 0 0 1 .2-.2q.15-.075.275-.075.25 0 .413.188.162.187.112.437l-.85 6h3.1q.35 0 .438.187.087.188-.113.513l-5.175 9.4a.4.4 0 0 1-.2.2.6.6 0 0 1-.275.075"
        fill="#1A1A1A"
      />
    </g>
  </svg>
    )
}
export default Icon